import topicsDir from "../__topicsDir";

/**
 * events data
 * イベント一覧データ
 * @props {string} date 日時（YYYY-MM-DD\THH:mm）
 * @props {string} title タイトル（html）
 * @props {string} [href] リンクURL
 */
export default [
	{
		date: "2021-01-12T11:00",
		title: `
<h4>新潟県医師会/新潟市医師会　在宅医療推進センターより</h4>
<p class="paragraph-indent">
●第2回新潟県ICTネットワーク連絡会開催のご案内（Zoom）<br>
<em>参加対象：</em>郡市医師会在宅医療推進センター長、コーディネーター、<br data-mq="pc"><span data-mq="pc">　　　　　</span>ICT事務担当者、ICT活用に興味のある医師会員、<br data-mq="pc"><span data-mq="pc">　　　　　</span>県・市町村関係職員等<br>
・<a href="${topicsDir}/2021/01-ICT_network-no2.pdf">第２回新潟県ICTネットワーク連絡会の開催について（ご案内）</a>
</p>
		`.trim().replace(/\t|\n/g, "")
	}
];
